export const duplicateCandidateEmailCode = 'DUPLICATE_CANDIDATE_EMAIL';

export const getDuplicateCandidateFromError = (error) => {
  const duplicateCandidate = error?.response?.data;

  if (duplicateCandidate?.code !== duplicateCandidateEmailCode) {
    return null;
  }

  return duplicateCandidate;
};

export const getDuplicateCandidateAction = ({ isRemoved, pk_Candidate } = {}) => {
  if (!pk_Candidate) {
    return 'notify';
  }

  return isRemoved ? 'restore' : 'focus';
};
